<template>
  <v-col cols="12" md="6">
    <v-card class="overflow-hidden fill-height">
      <v-card-text class="pa-0 fill-height">
        <div class="report-content-wrapper fill-height">
          <div class="report-content">
            <v-container class="py-4 px-5 text-body-2 text-sm-body-1">
              <v-row>
                <v-col cols="12">
                  <section-header class="mb-5">
                    {{ $t(`reports.${category}`) }}
                  </section-header>
                  <template v-if="category === 'efficiency'">
                    <p>{{ $t('reports.efficiency_info') }}</p>
                  </template>
                  <template v-else-if="category === 'capability'">
                    <p>{{ $t('reports.capability_info') }}</p>
                  </template>
                  <template v-else-if="category === 'leadership'">
                    <p v-if="personnelSurveyHasAnswers">{{ $t('reports.leadership_info') }}</p>
                    <p v-if="managementSurveyHasAnswers">{{ $t('reports.leadership_info2') }}</p>
                  </template>
                  <template v-else-if="category === 'economy_customers'">
                    <p>{{ $t('reports.economy_and_customers_info') }}</p>
                    <p>{{ $t('reports.economy_and_customers_info2') }}</p>
                  </template>
                </v-col>
              </v-row>
            </v-container>
          </div>
          <div class="report-chart">
            <report-overall-chart :category="category" :surveys="surveys"></report-overall-chart>
          </div>
          <div class="report-button-holder py-4 px-3">
            <basic-button color="primary" class="px-2" text @click="goToCategory">
              {{ $t(`reports.open_report`) }}
            </basic-button>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import ReportOverallChart from '@/components/Tenant/Reports/ReportOverallChart';
import BasicButton from '@/components/BasicButton';
import SectionHeader from '@/components/SectionHeader';
import categoryService from '@/service/category.service';

export default {
  name: 'ReportCategoryCard',
  components: {SectionHeader, BasicButton, ReportOverallChart},
  props: ['surveys', 'category', 'managementSurveyHasAnswers', 'personnelSurveyHasAnswers'],
  data() {
    return {};
  },
  computed: {
    categories() {
      return categoryService.tree[this.category];
    },
  },
  methods: {
    goToCategory() {
      this.$router.push({
        name: 'tenant_report_category',
        params: {
          category: this.category,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.report-content-wrapper {
  position: relative;
  min-height: 300px;

  .report-content {
    padding-right: 60px;
    padding-bottom: 50px;
  }

  .report-chart {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 60px;
  }

  .report-button-holder {
    position: absolute;
    left: 0;
    bottom: 0;
  }
}

@media screen and (min-width: 600px) {
  .report-content-wrapper {
    .report-content {
      padding-right: 110px;
      padding-bottom: 60px;
    }

    .report-chart {
      width: 100px;
    }
  }
}
</style>
